import { render, staticRenderFns } from "./leftList.vue?vue&type=template&id=05ae6ec8&scoped=true"
import script from "./leftList.vue?vue&type=script&lang=js"
export * from "./leftList.vue?vue&type=script&lang=js"
import style0 from "./leftList.vue?vue&type=style&index=0&id=05ae6ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae6ec8",
  null
  
)

export default component.exports